interface SaasPulseLoaderProps {
  compact?: boolean;
  className?: string;
  /** Bright day splash (default) vs a softer night wash. */
  tone?: 'bright' | 'night';
}

/** Soft indigo pulse rings for the ServiceApp loading screen. */
export function SaasPulseLoader({ compact = false, className = '', tone = 'bright' }: SaasPulseLoaderProps) {
  const ringBase = compact ? 'w-32 h-32' : 'w-56 h-56';
  const ringMid = compact ? 'w-44 h-44' : 'w-72 h-72';
  const ringOuter = compact ? 'w-56 h-56' : 'w-96 h-96';
  const bright = tone === 'bright';

  return (
    <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}>
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${ringOuter} rounded-full border animate-saas-pulse-ring ${
          bright ? 'border-indigo-300/40' : 'border-indigo-400/20'
        }`}
        style={{ animationDelay: '0s' }}
      />
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${ringMid} rounded-full border animate-saas-pulse-ring ${
          bright ? 'border-violet-300/45' : 'border-indigo-300/25'
        }`}
        style={{ animationDelay: '0.6s' }}
      />
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${ringBase} rounded-full border animate-saas-pulse-ring ${
          bright ? 'border-cyan-300/50' : 'border-cyan-300/20'
        }`}
        style={{ animationDelay: '1.2s' }}
      />
      <div
        className={
          bright
            ? 'absolute inset-0 bg-[radial-gradient(circle_at_50%_42%,rgba(99,102,241,0.16),rgba(34,211,238,0.08)_42%,transparent_62%)]'
            : 'absolute inset-0 bg-[radial-gradient(circle_at_50%_45%,rgba(99,102,241,0.16),transparent_55%)]'
        }
      />
    </div>
  );
}
